var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06573 9.04998C3.5904 5.21975 7.12074 2.54007 10.951 3.06475C12.8937 3.33087 14.5398 4.36951 15.6231 5.82964L15.7494 5.99997H12.5001C12.2239 5.99997 12.0001 6.22383 12.0001 6.49997C12.0001 6.77611 12.2239 6.99997 12.5001 6.99997H16.5001C16.7762 6.99997 17.0001 6.77611 17.0001 6.49997V2.49997C17.0001 2.22383 16.7762 1.99997 16.5001 1.99997C16.2239 1.99997 16.0001 2.22383 16.0001 2.49997V4.70729C14.7758 3.31847 13.0653 2.34504 11.0867 2.074C6.70929 1.47437 2.67461 4.53686 2.07498 8.91426C1.47535 13.2917 4.53784 17.3263 8.91524 17.926C13.2926 18.5256 17.3273 15.4631 17.9269 11.0857C18.0011 10.5444 18.0192 10.0079 17.9857 9.48208C17.9681 9.2065 17.7304 8.99737 17.4548 9.01497C17.1792 9.03258 16.9701 9.27025 16.9877 9.54583C17.017 10.0054 17.0012 10.4752 16.9362 10.95C16.4115 14.7802 12.8812 17.4599 9.05095 16.9352C5.22073 16.4105 2.54105 12.8802 3.06573 9.04998Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.bf6d2f9eefb515d48b176e3745caf667.svg";
export { ForwardRef as ReactComponent };